<template>
  <b-card
    class="full-width"
    border-variant="info"
    header-bg-variant="primary"
    header-text-variant="white"
  >
    <div slot="header">
      <strong>{{ title }}</strong>
    </div>
    <div class="row">
      <div class="col-md-4">
        <a-radio-group :value="type" class="gr-50" buttonStyle="solid">
          <a-radio-button
            v-for="(opt, idx) in types"
            :checked="type === opt"
            buttonStyle="solid"
            :key="idx"
            :value="opt"
            @click="(e) => changeType(opt)"
            >{{ opt }}</a-radio-button
          >
        </a-radio-group>
      </div>

      <div class="col-md-6">
        <a-input
          size="default"
          placeholder="Item Name"
          type="text"
          v-model="itemBuffer.name"
          v-if="objectType !== true"
          class
        ></a-input>
      </div>
      <div class="col-md-2" v-if="$props.currentroute !== 'ViewAttribute'">
        <eb-button
          v-if="objectType !== true"
          classic="mr-1 btn-primary"
          text="Add"
          @click="addItem"
          :disabled="itemBuffer.name && itemBuffer.name.length <= 0"
          icon="fa fa-plus-circle mr-1"
          iconSide="left"
        ></eb-button>
      </div>
    </div>
    <hr />
    <b-row>
      <div
        v-for="(item, idx) in items"
        :key="'arr' + idx"
        class="item well ml-4"
      >
        <div
          style="position: relative;"
        >
          <template v-if="edit_idx !== idx">
            <div class="item_name">{{ item.name }}</div>
          </template>
          <template v-else>
            <a-input
              placeholder="Item name"
              type="text"
              v-model="items[idx].name"
              class="item_name"
            />
          </template>
        </div>
        <i
          class="fa fa-pencil edit action icon"
          style="background: #fe7b08; border: #fe7b08;"
          v-if="$props.currentroute !== 'ViewAttribute'"
          @click="edit(idx)"
        ></i>
        <i
          class="fa fa-trash bin action"
          v-if="$props.currentroute !== 'ViewAttribute'"
          @click="del(idx)"
        ></i>
      </div>
    </b-row>
  </b-card>
</template>

<style>
.flex {
  display: flex;
}
.gr-50 {
  flex-grow: 0.5;
}
.gr-45 {
  flex-grow: 0.45;
}
.type-option {
  padding: 3px 0 0 0;
}
.item {
  display: flex;
}

.item_name {
  width: 100px !important;
  margin: 0 10px 0 0;
  transition: all 0.5s ease;
}

.well {
  padding: 10px;
  margin: 5px;
  width: fit-content;
  border-radius: 4px;
  box-shadow: 1px 2px 2px rgba(163, 156, 156, 0.5);
}
.well .name {
  min-width: 150px;
}
.bin {
  color: red;
  cursor: pointer;
}
.edit {
  color: var(--primary) !important;
  cursor: pointer;
}
.action {
  font-size: 21px;
  margin: 2px 8px;
  transition: all 0.1s ease;
}
.action:hover {
  transform: scale(1.05);
}
.icon {
  margin-top: 5px;
  margin-bottom: 5px;
}
</style>

<script>
import ebButton from "@/components/FormElements/Button";

export default {
  data() {
    return {
      itemBuffer: {},
      edit_idx: null,
    };
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    currentroute: {
      type: String,
    },
    type: {
      type: String,
      required: true,
    },
    types: {
      type: Array,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
    objectType: {
      type: Boolean,
    },
  },
  methods: {
    changeType: function (e) {
      this.$emit("changeType", e);
    },
    modifyItem: function (e) {
      this.$emit("modify", e);
    },
    addItem: function (e) {
      this.$emit("add", this.itemBuffer);
      this.itemBuffer = {};
    },
    edit: function (e) {
      this.edit_idx = e;
    },
    del: function (e) {
      this.$emit("delete", e);
    },
  },
  mounted() {
    this.$message.config({
      top: "80px",
    });
  },
  components: {
    ebButton,
  },
};
</script>
